import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useCredentialsClient } from "@/features/credentials/hooks/use-credentials-client";
import type { CreateCredentialPayload } from "@/features/credentials/models/credential";
import { credentialsQueryKeys } from "@/features/credentials/queries/credentials-query-keys";

export function useCreateCredentialMutation() {
  const queryClient = useQueryClient();
  const { productToken } = useAuth();
  const credentialsClient = useCredentialsClient();

  return useMutation({
    mutationFn: ({
      sport,
      organizationId,
      payload,
    }: {
      sport: string;
      organizationId: string;
      payload: CreateCredentialPayload;
    }) =>
      credentialsClient.createCredential({
        productToken: productToken as string,
        sport,
        organizationId,
        payload,
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: credentialsQueryKeys.list({
          sport: variables.sport,
          organizationId: variables.organizationId,
        }),
      });
    },
  });
}
